export default __webpack_public_path__ + "static/media/hihat.841b3716.ogg";